import classNames from "classnames";
import { PropsWithChildren } from "react";

import { useIsClientSide } from "@/utils/hooks/isClient.hook";

import { useCallToActionContext } from "./callToAction.context";

type CallToActionComponentProps = PropsWithChildren<{
    marginClass?: string;
}>;

const CallToActionComponent = ({
    marginClass,
    children
}: CallToActionComponentProps) => {
    const { trackingProperties } = useCallToActionContext();
    const isClient = useIsClientSide();

    return (
        <div
            {...(isClient && trackingProperties.impression)}
            className={classNames("mb-3", marginClass)}
        >
            {children}
        </div>
    );
};

export { CallToActionComponent };
